export default __webpack_public_path__ + "static/media/WardukeSketch.d97c40ab.png";